import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'

import { breakManagementActions } from '../breakManagementSagas'
import { selectBreakManagement } from '../breakManagementSelectors'
import { splitElapsed } from '../helpers/splitElapsed'
import { StartButtonOverrides, StopButtonOverrides } from './styled-components'

const TICK_MS = 1000

const useBreakToggle = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueue } = useSnackbar()
  const { breakState, clockOffsetMs, isSubmitting } = useSelector(selectBreakManagement)
  const ownBreak = breakState?.my_break ?? null
  const startedAt = ownBreak?.started_at ?? null
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (startedAt === null) return

    setNow(Date.now())
    const interval = setInterval(() => setNow(Date.now()), TICK_MS)

    return () => clearInterval(interval)
  }, [startedAt])

  const elapsed = startedAt === null ? null : splitElapsed(now + clockOffsetMs - Date.parse(startedAt))

  const toggle = () => {
    if (ownBreak === null) {
      dispatch({ type: breakManagementActions.START_BREAK, force: false, enqueue })
      return
    }

    dispatch({ type: breakManagementActions.STOP_BREAK, breakId: ownBreak.id, enqueue })
  }

  return {
    isOnBreak: ownBreak !== null,
    buttonOverrides: ownBreak === null ? StartButtonOverrides : StopButtonOverrides,
    label: t(ownBreak === null ? 'breakManagement:start' : 'breakManagement:stop'),
    timer: elapsed === null ? '' : t('breakManagement:timer', { ...elapsed }),
    isDisabled: isSubmitting || breakState === null,
    toggle,
  }
}

export default useBreakToggle
